import {Dispatchable} from "../../stem-core/base/Dispatcher";

class SDKState extends Dispatchable {
    preferredEmail: string | null = null;
    allowUserToCoverFees = false;
    hideWallet = false;

    update(obj: Partial<SDKState>): void {
        Object.assign(this, obj);
        this.dispatchChange(obj);
    }
}

export const sdkState = new SDKState();
